import { render } from "./Cv.vue?vue&type=template&id=4c2f5384"
import script from "./Cv.vue?vue&type=script&lang=js"
export * from "./Cv.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__